import * as React from "react";
import type { SVGProps } from "react";
const SvgShoppingCart = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M1 0a1 1 0 1 0 0 2zm4 1 .98-.196A1 1 0 0 0 5 0zm2.68 13.39.98-.195v-.001zm2 1.61v-1h-.02zm9.72 0 .02-1h-.02zm2-1.61.98.195.002-.008zM23 6l.982.187A1 1 0 0 0 23 5zM6 5a1 1 0 0 0 0 2zm3 16v2a2 2 0 0 0 2-2zm0 0H7a2 2 0 0 0 2 2zm0 0v-2a2 2 0 0 0-2 2zm0 0h2a2 2 0 0 0-2-2zm11 0v2a2 2 0 0 0 2-2zm0 0h-2a2 2 0 0 0 2 2zm0 0v-2a2 2 0 0 0-2 2zm0 0h2a2 2 0 0 0-2-2zM1 2h4V0H1zm3.02-.804 2.68 13.39 1.96-.392L5.98.804zM6.7 14.585a3 3 0 0 0 1.06 1.752l1.255-1.558a1 1 0 0 1-.354-.584zm1.06 1.752A3 3 0 0 0 9.7 17l-.04-2a1 1 0 0 1-.645-.22zM9.68 17h9.72v-2H9.68zm9.7 0a3 3 0 0 0 1.94-.663l-1.255-1.558a1 1 0 0 1-.646.221zm1.94-.663a3 3 0 0 0 1.06-1.752l-1.96-.39a1 1 0 0 1-.355.584zm1.062-1.76 1.6-8.39-1.964-.374-1.6 8.39zM23 5H6v2h17z"
    />
  </svg>
);
export default SvgShoppingCart;
